const ProtectionSet = require('../../../../model/ProtectionSet');
const SERVER_API = 'api/v1/';

class ProtectionSetPickerPersistenceService {
    constructor(config, $filter, $rootScope, crudService, sharedPersistenceService, utilsService, storageService) {
        this.config = config;
        this._crudService = crudService;
        this._sharedPersistence = sharedPersistenceService;
        this._utilsService = utilsService;
        this._storageService = storageService;
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.proxyUrl = config.proxyUrl;
        this.registryUrl = config.registryUrl;

        this.REST_ENDPOINTS = this._sharedPersistence.getRestEndpoints();
    }

    saveProtectionSet(sub, protectionSet) {
        const data = {
            subscriptionUuid: sub.uuid,
            subscriptionName: sub.name,
            protectionSetUuid: protectionSet.uuid,
            protectionSetName: protectionSet.name
        }

        return this._crudService.put(this.proxyUrl + SERVER_API + this.REST_ENDPOINTS.SCOPE_REST, data, false, false, true, null).then(res => {
            return res.data;
        })
    }

    getScopeSubscriptions() {
        return this._crudService.get(this.registryUrl + SERVER_API + this.REST_ENDPOINTS.SCOPE_REST + '/subscriptions', false, false, false, false, true, true, true).then(res => {
            return res.data.entities[0].subscriptions;
        });
    }

    getProtectionSetsBySub(sub, protectionSetName) {
        if (protectionSetName) {
            return this._crudService.get(sub.managerEndpointUrl + SERVER_API + this.REST_ENDPOINTS.SCOPE_REST + '/subscriptions/' + sub.uuid + '/tree?filter=name%23%23' + protectionSetName, false, false, false, false, true, true, false).then(res => {
                return res.data.entities;
            });
        } else {
            return this._crudService.get(sub.managerEndpointUrl + SERVER_API + this.REST_ENDPOINTS.SCOPE_REST + '/subscriptions/' + sub.uuid + '/tree', false, false, false, false, true, true, false).then(res => {
                return res.data.entities;
            });
        }
    }

    getResourceGroups(sub, rGName) {
        if (rGName) {
            return this._crudService.get(sub.managerEndpointUrl + SERVER_API + 'subscriptions/' + sub.uuid + '/resourceGroups?filter=name%23%23' + rGName, null, null, null, null, null, true, true).then(res => {
                return res.data.entities;
            })
        } else {
            return this._crudService.get(sub.managerEndpointUrl + SERVER_API + 'subscriptions/' + sub.uuid + '/resourceGroups', null, null, null, null, null, true, true).then(res => {
                return res.data.entities;
            })
        }
    }

    deleteProtectionSet(sub, cg) {
        return this._crudService.del(sub.managerEndpointUrl + SERVER_API + 'subscriptions/' + sub.uuid + `/${this.REST_ENDPOINTS.PROTECTION_SETS_REST}/${encodeURI(cg.uuid)}`, false, false, false, true, true, true);
    }

    createProtectionSet(sub, cg) {
        return this._crudService.post(sub.managerEndpointUrl + SERVER_API + 'subscriptions/' + sub.uuid + '/' + this.REST_ENDPOINTS.PROTECTION_SETS_REST, cg.toRaw(), false, false, null, true, true);
    }

    updateProtectionSet(sub, cg) {
        return this._crudService.put(sub.managerEndpointUrl + SERVER_API + 'subscriptions/' + sub.uuid + `/${this.REST_ENDPOINTS.PROTECTION_SETS_REST}/${encodeURI(cg.uuid)}`, cg.toRaw(), false, false, true, true);
    }

    newProtectionSet() {
        return new ProtectionSet();
    }
}

ProtectionSetPickerPersistenceService.$inject = ['config', '$filter', '$rootScope', 'crudService', 'sharedPersistenceService', 'utilsService', 'storageService'];

module.exports = ProtectionSetPickerPersistenceService;



// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/protectionSetPicker/protectionSetPicker.persistence.service.js